<div class="container" loading-spin [isLoading]="isLoading" [loadingSize]="'big'">
    <tam-timeline [data]="records">
        <ng-template #content let-dataItem="dataItem">
            <div class="header-area">
                <div class="one-header">
                    <div class="header-left">
                        <div class="user-info" [title]="dataItem.record?.user?.shortName"
                            (click)="onClickUser($event, dataItem.record)">
                            {{dataItem.record?.user?.shortName}}
                        </div>
                        <div class="status-info text-ellipsis">
                            {{getActionName(dataItem.record)}} the task
                            <span class="text-ellipsis" *ngIf="isTargetContentVisible(dataItem)"
                                [title]="dataItem.record?.data?.targetTaskName">
                                &nbsp;to {{dataItem.record?.data?.targetTaskName}}
                            </span>
                        </div>
                    </div>
                    <div class="header-right caption-2">
                        {{dataItem.record?.time|date:'dd-MMM-yyyy HH:mm'}}
                    </div>
                </div>
            </div>
            <div class="detail-area" *ngIf="isDetailAreaVisible(dataItem.record)">
                <div class="line one-detail"></div>
                <div class="detail-header text-ellipsis">
                    {{dataItem.record?.data?.taskName}}
                </div>
                <div class="one-detail" *ngFor="let keyValue of dataItem.fieldsArray">
                    <ng-container *ngIf="keyValue.value.fieldDefinition.type!=='richEditor'">
                        <div class="field-name">
                            {{keyValue.value.fieldDefinition.name}} <span class="required-field"
                                *ngIf="keyValue.value.fieldDefinition.require">*</span>
                        </div>
                        <div class="field-value"
                            *ngIf="keyValue.value.fieldDefinition.type==='entity' || keyValue.value.fieldDefinition.type==='user'">
                            <div *ngIf="keyValue.value.value && isEntityArray(keyValue.value.value)"
                                class="div-flex wrap-flex-div">
                                <div *ngFor="let linkItem of keyValue.value.value;let i= index"
                                    [ngClass]="{'no-wrap-entity-div': !isEntityDivWrap(keyValue.value.value), 'div-flex': isEntityDivWrap(keyValue.value.value)}">
                                    <a href="{{getEntityRelativeLink(linkItem)}}"
                                        target='_blank'>{{linkItem.shortName}}{{i+1
                                        === keyValue.value.value.length?'':';'}}</a>&nbsp;
                                </div>
                            </div>
                            <div *ngIf="keyValue.value.value && !isEntityArray(keyValue.value.value)" class="div-flex">
                                <a href="{{getEntityRelativeLink(keyValue.value.value)}}"
                                    target='_blank'>{{keyValue.value.value.shortName}}</a>
                            </div>
                        </div>
                        <kendo-numerictextbox class="field-value" *ngIf="keyValue.value.fieldDefinition.type==='number'"
                            [value]="keyValue.value.value" [format]="getFormatForNumber(keyValue.value)"
                            [spinners]="false" [readonly]="true">
                        </kendo-numerictextbox>
                        <div class="field-value" *ngIf="keyValue.value.fieldDefinition.type==='text'">
                            {{keyValue.value?.value}}
                        </div>
                        <div class="multi-line-field-value" *ngIf="keyValue.value.fieldDefinition.type==='textArea'"
                            [title]="keyValue.value?.value">
                            <span>{{keyValue.value?.value}}</span>
                        </div>
                        <div class="field-value" *ngIf="keyValue.value.fieldDefinition.type==='currency'">
                            {{keyValue.value?.value|currency:'CAD':'symbol-narrow':'1.0-0'}}
                        </div>
                        <div class="field-value" *ngIf="keyValue.value.fieldDefinition.type==='date'">
                            {{keyValue.value?.value|date}}
                        </div>
                        <tam-file-info class="field-value" *ngIf="keyValue.value.fieldDefinition.type==='file'"
                            [config]="keyValue.value?.value" [isDefaultToPreview]="true">
                        </tam-file-info>
                        <div class="multi-line-field-value" *ngIf="keyValue.value.fieldDefinition.type==='richEditor'">
                            <!-- Only show the rich editor content in history, Doesn't need to support it for now, please refer to note-detail-body when handling it-->
                            <span [innerHtml]="keyValue.value?.value">
                            </span>
                        </div>
                        <div class="check-list-field-value" *ngIf="keyValue.value.fieldDefinition.type==='checkList'">
                            <div class="checked-items-container">
                                <div class="checked-item-line" *ngFor="let line of getCheckedItems(keyValue.value)">
                                    <span class="check-list-value" kendoTooltip title="{{line}}">{{line}}</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="detail-area" *ngIf="dataItem.record.data.comment">
                <div class="line one-detail"></div>
                <div class="one-detail one-comment">
                    {{dataItem.record?.data?.comment}}
                </div>
            </div>
        </ng-template>
    </tam-timeline>
</div>